import { StringEnumSchema } from '@flysas-tech/book-value-stream-models';
import { String, Static, Object as TObject, Record, Array } from '@sinclair/typebox';

export type Airport = Static<typeof Airport>;
export const Airport = TObject({
  airportCode: String(),
  airportName: String(),
  cityCode: String(),
  cityName: String(),
  countryCode: String(),
  countryName: String(),
  regionCode: String(),
  regionName: String(),
});

export type City = Static<typeof City>;
export const City = TObject({
  cityCode: String(),
  cityName: String(),
  countryCode: String(),
  countryName: String(),
  airportCodes: String(),
  airports: Array(Airport),
});

export type CityMap = Static<typeof CityMap>;
export const CityMap = Record(String(), City);

export const AirportPartners = {
  SKYTEAM: 'SKYTEAM',
  SAS: 'SK',
} as const;

export type AirportPartnerOperatedNetwork = Static<typeof AirportPartnerOperatedNetwork>;
export const AirportPartnerOperatedNetwork = StringEnumSchema(AirportPartners);
